export default __webpack_public_path__ + "static/media/dashboard-stat-icon-white.ab20a62a.svg";